import React from "react";

export interface IconProps extends React.SVGAttributes<HTMLOrSVGElement> {
  size?: number;
}

export const IconConfigurations: React.FC<IconProps> = ({ size = 24, ...rest }) => {
  return (
    <>
      <svg 
        width={size}
        height={size}
        viewBox="0 0 25 25"
        fill="#616161"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
        >
        <path 
          d="M21.7711 13.6762C21.8225 13.3012 21.8482 12.9137 21.8482 12.5012C21.8482 12.1012 21.8225 11.7012 21.7583 11.3262L24.367 9.35122C24.5983 9.17622 24.6625 8.83872 24.5212 8.58872L22.0538 4.43872C21.8996 4.16372 21.5784 4.07622 21.2956 4.16372L18.2243 5.36372C17.5818 4.88872 16.9007 4.48872 16.1425 4.18872L15.6799 1.01372C15.6285 0.713721 15.3715 0.501221 15.063 0.501221H10.1284C9.81995 0.501221 9.57578 0.713721 9.52438 1.01372L9.06176 4.18872C8.30356 4.48872 7.60963 4.90122 6.97994 5.36372L3.90862 4.16372C3.6259 4.06372 3.30463 4.16372 3.15043 4.43872L0.695939 8.58872C0.541731 8.85122 0.593133 9.17622 0.850148 9.35122L3.45884 11.3262C3.39459 11.7012 3.34319 12.1137 3.34319 12.5012C3.34319 12.8887 3.36889 13.3012 3.43314 13.6762L0.824446 15.6512C0.593133 15.8262 0.52888 16.1637 0.670238 16.4137L3.13758 20.5637C3.29178 20.8387 3.61305 20.9262 3.89577 20.8387L6.96709 19.6387C7.60962 20.1137 8.29071 20.5137 9.04891 20.8137L9.51153 23.9887C9.57579 24.2887 9.81995 24.5012 10.1284 24.5012H15.063C15.3715 24.5012 15.6285 24.2887 15.667 23.9887L16.1297 20.8137C16.8878 20.5137 17.5818 20.1137 18.2115 19.6387L21.2828 20.8387C21.5655 20.9387 21.8868 20.8387 22.041 20.5637L24.5083 16.4137C24.6625 16.1387 24.5983 15.8262 24.3541 15.6512L21.7711 13.6762ZM12.5957 17.0012C10.0513 17.0012 7.96944 14.9762 7.96944 12.5012C7.96944 10.0262 10.0513 8.00122 12.5957 8.00122C15.1401 8.00122 17.222 10.0262 17.222 12.5012C17.222 14.9762 15.1401 17.0012 12.5957 17.0012Z"/>
      </svg>

    </>
  );
};
